<template>
  <section class="section  mobile_div section_bg custom_page_v2 first_page" >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <card class="loading_div" v-if="is_load==false">
      <h2>{{ load_message }}</h2>
    </card>
    <div v-if="is_load">


      <div class="section_header mobile_div back_div_element" v-if="is_load"   >
        <router-link tag="a" class="btn" :to="{name: 'shop_setting',query: { tab_active: 'items' }}"  ><i class="fa fa-backward"></i> Назад</router-link>

      </div>

      <div class="" v-if="is_load">
        <div class="section_header nocenter mobile_div">
          <h2 class="text-center">Редактировать товар</h2>
          <div class="container-fluid">
            <div class="form-group"  >
              <label >Название </label>
              <input type="text" class="form-control " v-model="newItem.title">
            </div>
            <div class="form-group" >
              <label for="exampleCategoryitem">Категория </label>
              <select id="exampleCategoryitem"  v-model="newItem.category_id" required
                  class="form-control">

                <option v-if="categorys.length>0" v-for="category in categorys" :value="category.last_id"
                    :key="category.last_id">{{
                    category.title
                  }}
                </option>



              </select>


            </div>
            <div class="form-group"  >
              <label >Цена </label>
              <input type="text" class="form-control " v-model="newItem.price">
            </div>
            <div class="form-group" >
              <label for="exampleCategoryitem56">Валюта </label>
              <select id="exampleCategoryitem56"   v-model="newItem.currency" required
                  class="form-control">

                <option v-if="currencys.length>0" v-for="(currency,currency_key) in currencys" :value="currency"
                    :key="currency_key">{{
                    currency
                  }}
                </option>



              </select>


            </div>
            <div class="form-group"  >
              <label >Загрузите изображение </label>
              <input type="file" accept="image/*" @change="uploadImageItem($event)" id="file-input">

            </div>
            <div class="col-3" v-if="newItem.photos.length>0" v-for="(photo,photo_key) in newItem.photos"
                :key="photo_key">
              <p class="mt-2"><img :src='photo' class="img img-thumbnail" ><button class="btn" @click="deletePhoto(photo_key)" type="button">Удалить</button></p>
            </div>
            <div class="form-group" >
              <label >Количество </label>
              <input type="text" class="form-control " v-model="newItem.count">
            </div>
            <div class="form-group"  >
              <label >Подзаказ? </label>
              <input type="checkbox" class="form-check-inline " v-model="newItem.islimited">
            </div>
            <div class="col-12 alert card"  >
              <h2 class="text-center">Варианты товара</h2>
              <div class="form-group" >
                <label >Название варианта </label>
                <input type="text" class="form-control " v-model="shop_new_variant.title">
              </div>
              <div class="form-group" >
                <label >Стоимость товара </label>
                <input type="number" class="form-control " v-model="shop_new_variant.price">
              </div>
              <div class="form-group" >
                <label >Количество </label>
                <input type="number" class="form-control " v-model="shop_new_variant.count">
              </div>
              <div class="form-group"  >
                <button type="button" class="btn "  @click="addNewVariants()">Добавить вариант</button>

              </div>

              <div v-if="newItem.variants.length>0" v-for="(option,option_key) in newItem.variants"
                  :key="option_key">
                <div class="form-group" >
                  <label >Название варианта </label>
                  <input type="text" class="form-control " v-model="newItem.variants[option_key].title">
                </div>
                <div class="form-group" >
                  <label >Стоимость товара </label>
                  <input type="number" class="form-control " v-model="newItem.variants[option_key].price">
                </div>
                <div class="form-group" >
                  <label >Количество </label>
                  <input type="number" class="form-control " v-model="newItem.variants[option_key].count">
                </div>
                <div class="form-group"  >
                  <button class="btn " @click="deleteVariant(option_key)" type="button">Удалить</button>
                </div>

              </div>
            </div>
            <div class="col-12 alert card"  >
              <h2 class="text-center">Опции</h2>
              <div class="form-group" >
                <label >Название опции </label>
                <input type="text" class="form-control " v-model="shop_new_option.title">
              </div>
              <div class="form-group" >
                <label >Стоимость </label>
                <input type="number" class="form-control " v-model="shop_new_option.price">
              </div>
              <div class="form-group"  >
                <button type="button" class="btn "  @click="addNewOptions()">Добавить опцию</button>

              </div>

              <div v-if="newItem.options.length>0" v-for="(option,option_key) in newItem.options"
                  :key="option_key">
                <p class="mt-2"><b>{{ option.title}}</b> {{ option.price }} {{newItem.currency}} <button class="btn " @click="deleteOption(option_key)" type="button">Удалить</button></p>
              </div>
            </div>
            <div class="col-12 alert card"  >
              <h2 class="text-center">Опции</h2>
              <div class="form-group" >
                <label >Название опции </label>
                <input type="text" class="form-control " v-model="shop_new_option.title">
              </div>
              <div class="form-group" >
                <label >Стоимость </label>
                <input type="number" class="form-control " v-model="shop_new_option.price">
              </div>
              <div class="form-group"  >
                <button type="button" class="btn "  @click="addNewOptions()">Добавить опцию</button>

              </div>

              <div v-if="newItem.options.length>0" v-for="(option,option_key) in newItem.options"
                  :key="option_key">
                <p class="mt-2"><b>{{ option.title}}</b> {{ option.price }} {{newItem.currency}} <button class="btn " @click="deleteOption(option_key)" type="button">Удалить</button></p>
              </div>
            </div>
            <editorjsinput :blocks_json="newItem.content_json.blocks" ref="editorjs" ></editorjsinput>


            <div class="alert alert-danger" v-if="iserror==true">
              <p>{{ error_message }}</p>
            </div>
            <base-button  @click="onSave"  >Сохранить</base-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import Editorjsinput from "@/models/Editorjsinput";
import Vue from "vue";
import UserModel from "@/models/UserModel";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "AddItem",
  data() {

    var app = this;

    return {
      "load_message":"Идет загрузка...",
      "currencys":null,
      "shop_new_option":{
        "title":"",
        "price":0,
      },
      "shop_new_variant":{
        "title":"",
        "price":0,
        "count":0,
      },
      "newItem": {
        "title":null,
        "currency":null,
        "price":null,
        "islimited":false,
        "count":0,
        "photos":[],
        "options":[],
        "variants":[],
        "content_json":[],
        "category": null,
        'json': null,
        'enable':true,

      },
      'example_blocks':[
        {
          "type": "header",
          "data": {
            "text": "Детальное описание товара",
            "level": 2
          }
        },

        {
          "type": "paragraph",
          "data": {
            "text": "Введите тут детальное описание товара",
          }
        },

      ],
      'is_load':false,
      'categorys':[],
      'iserror':false,
      'error_message':'',
      'user':null,




    }
  },
  mounted: function () {
    var app = this;
    var user=UserModel.get();
    let id = app.$route.params.id;
    if(user && user.isshop==1){
      Api.loadShopMyItem(id,function(data){
        if(!data.item.variants){
          data.item.variants=[];
        }
        app.newItem=data.item;
        app.user=user;

        //app.newItem.currency=app.currencys[0];

        Api.loadShopCategorys(function(data){
          app.categorys=data.categorys;
          app.currencys=data.currencys;
          app.is_load = true;

        });
      })

    }



  },components: {
    'editorjsinput': Editorjsinput,LoadingBlock
  },methods:{
    setLoad(message="Идет загрузка"){
      var app=this;

      app.load_message=message;
      app.is_load=false;
    },
    disableLoad(){
      var app=this;

      app.load_message="Идет загрузка";
      app.is_load=true;
    },
    deletePhoto(photo_key){

      var key=photo_key;
      var app=this;
      if(app.newItem.photos[key]){
        app.newItem.photos.splice(key, 1);

      }
    },
    deleteVariant(option_key){

      var key=option_key;
      var app=this;
      if(app.newItem.variants[key]){
        app.newItem.variants.splice(key, 1);

      }
    },
    deleteOption(option_key){

      var key=option_key;
      var app=this;
      if(app.newItem.options[key]){
        app.newItem.options.splice(key, 1);

      }
    },
    uploadImageItem(){


      var app=this;

      let data = new FormData();
      data.append("image",event.target.files[0]);

      // let config = {
      //   header : {
      //     'Content-Type' : 'image/png'
      //   }
      // }
      app.setLoad("Загрузка изображения...");
      Api.loadImage(data,function(data){

        app.disableLoad();
        app.newItem.photos.push(data.file.url);

      })

      // axios.put(
      //     URL,
      //     data,
      //     config
      // ).then(
      //     response => {
      //
      //     }
      // )
    },
    addNewVariants(){
      var app=this;
      var new_variant=app.shop_new_variant;

      if(new_variant.title.length>0 ){
        app.newItem.variants.push({"title":new_variant.title,"price":new_variant.price,"count":new_variant.count});
        app.shop_new_variant.title="";
        app.shop_new_variant.price=0;
        app.shop_new_variant.count=0;

      }
    },
    addNewOptions(){
      var app=this;
      var new_option=app.shop_new_option;

      if(new_option.title.length>0 ){
        app.newItem.options.push({"title":new_option.title,"price":new_option.price});
        app.shop_new_option.title="";
        app.shop_new_option.price=0;

      }
    },
    onSave(){
      var app=this;
      app.setLoad("Сохранение информации..");
      app.$refs.editorjs.save(function(editor_js_data){

        var newItem=app.newItem;
        newItem.content_json=editor_js_data;

        Api.addItem(newItem, function () {
          app.iserror = false;


          app.$router.push({name: 'shop_setting',query: { tab_active: 'items' }});
        }, function (message) {
          app.iserror = true;
          app.error_message = message;
        })
        // var newWork=app.newWork;
        //
        // newWork['json']=editor_js_data;
        // Api.addWork(newWork, function () {
        //   app.iserror = false;
        //   app.data = [];
        //
        //   app.$router.push({name: 'portfolio'});
        //
        //
        // }, function (message) {
        //   app.iserror = true;
        //   app.error_message = message;
        // })

      });
    },


  },
}
</script>

<style scoped>

</style>